import { z } from 'zod'

export const orderBookLevelSchema = z.object({
  price: z.number(),
  quantity: z.number(), // lots
})
export type OrderBookLevelDto = z.infer<typeof orderBookLevelSchema>

export const orderBookTickSchema = z.object({
  instrumentUid: z.string(),
  bids: z.array(orderBookLevelSchema),
  asks: z.array(orderBookLevelSchema),
  ts: z.string(),
  limitUp: z.number().nullable(),
  limitDown: z.number().nullable(),
})
export type OrderBookTickDto = z.infer<typeof orderBookTickSchema>
